module.exports = __webpack_public_path__ + "img/connecting-the-world.63719d99.webp";